import { algoliasearch } from 'algoliasearch';
import aa from 'search-insights';
import { ALGOLIA_CONFIG } from '@libTs/cms.globals';

const { appId, searchKey, indexName } = ALGOLIA_CONFIG;

export const searchClient = algoliasearch(appId, searchKey);
export { indexName };

export type AlgoliaHighlight = {
  value: string;
  matchLevel: 'full' | 'partial' | 'none';
};

export type AlgoliaHit = {
  objectID: string;
  title: string;
  url: string;
  type: string;
  sectionHandle: string;
  image?: string;
  seoTitle: string;
  seoKeywords: string;
  seoDescription: string;
  postDate: string;
  date?: string;
  dateTimestamp?: number;
  _highlightResult: {
    title?: AlgoliaHighlight;
    seoDescription?: AlgoliaHighlight;
    seoKeywords?: AlgoliaHighlight;
  };
};

export const BASE_SEARCH_PARAMS = {
  highlightPreTag: '<em>',
  highlightPostTag: '</em>',
  removeWordsIfNoResults: 'allOptional' as const,
};

let insightsReady = false;
export const setupInsights = (): void => {
  if (insightsReady) return;
  aa('init', { appId, apiKey: searchKey, useCookie: true });
  insightsReady = true;
};

export const trackClick = (params: {
  eventName: string;
  queryID: string;
  objectID: string;
  position: number;
}): void => {
  aa('clickedObjectIDsAfterSearch', {
    userToken: aa('getUserToken')?.toString(),
    eventName: params.eventName,
    index: indexName,
    queryID: params.queryID,
    objectIDs: [params.objectID],
    positions: [params.position],
  });
};

const RECENT_KEY = 'sks-recent-searches';
const RECENT_MAX = 5;

export const getRecentSearches = (): string[] => {
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
};

export const pushRecentSearch = (term: string): string[] => {
  const query = term.trim();
  if (!query) return getRecentSearches();
  const next = [query, ...getRecentSearches().filter((t) => t !== query)].slice(
    0,
    RECENT_MAX,
  );
  try {
    localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  } catch {
    /* ignore quota / disabled storage */
  }
  return next;
};
